import React from "react";
import "./ScreenHeading.css";

export function ScreenHeading(props) {
  return (
    <div className={"heading-container"}>
      <div className={"screen-heading"}>
        <span>{props.title}</span>
      </div>
      <div className={"heading-separator"}>
        <div className={"separator-line"} />
      </div>
      {props.subHeading ? (
        <div className={"screen-sub-heading"}>
          <span>{props.subHeading}</span>
        </div>
      ) : (
        <div />
      )}
    </div>
  );
}
